import { Link } from 'react-router-dom';

const Footer = () => {
  const footerLinks = [
    {
      title: '회사소개',
      links: [
        { name: '회사 개요', href: '#about' },
        { name: '사업 계획', href: '#business-plan' },
        { name: '특허 및 인증', href: '#patents' },
      ],
    },
    {
      title: '제품 정보',
      links: [
        { name: '제품 특징', href: '#features' },
        { name: '세대별 미터기', href: '#generation-meter' },
        { name: '카탈로그', href: '#catalog' },
      ],
    },
    {
      title: '고객 지원',
      links: [
        { name: '문의하기', href: '#contact' },
        { name: '광센서 수도미터', href: '#social-issues' },
        { name: '영상 자료', href: '#video' },
      ],
    },
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#', label: 'Facebook' },
    { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
    { icon: 'ri-linkedin-fill', href: '#', label: 'LinkedIn' },
    { icon: 'ri-youtube-fill', href: '#', label: 'YouTube' },
  ];

  return (
    <footer className="bg-gradient-to-br from-teal-800 via-teal-900 to-[#0a3d4f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* 회사 정보 */}
          <div className="col-span-2">
            <div className="flex items-center gap-3 mb-4 md:mb-6">
              <img
                src="https://static.readdy.ai/image/2299103fa86076f2ed06076e2d6cbff8/b0216ecd9824ced9791064a8a701a53c.png"
                alt="ROBO Asset Grid Logo"
                className="h-8 md:h-10 w-auto"
              />
            </div>
            <p className="text-sm md:text-base text-teal-200/80 font-medium leading-relaxed mb-4 md:mb-6">
              광학 센싱 기술을 활용한 스마트 디지털 수도미터기 전문 기업으로,
              친환경 소재와 IoT 기술을 결합하여 미래형 계량 솔루션을 제공합니다.
            </p>
            <div className="space-y-1.5 md:space-y-2 text-sm md:text-base text-teal-200/70 font-medium">
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line text-teal-300 mt-0.5 flex-shrink-0"></i>
                <span>경기 시흥시 은계남길 32 성강해오름 지식산업센터 7층 705호</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-teal-300 flex-shrink-0"></i>
                031-313-2663
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-smartphone-line text-teal-300 flex-shrink-0"></i>
                010-3319-6611
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-teal-300 flex-shrink-0"></i>
                tel9060@gmail.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-printer-line text-teal-300 flex-shrink-0"></i>
                0504-229-7701
              </p>
            </div>
          </div>

          {/* 링크 섹션 */}
          {footerLinks.map((section, idx) => (
            <div key={idx}>
              <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4 text-white">
                {section.title}
              </h4>
              <ul className="space-y-2 md:space-y-3">
                {section.links.map((link, lIdx) => (
                  <li key={lIdx}>
                    <a
                      href={link.href}
                      className="text-sm md:text-base text-teal-200/70 hover:text-teal-300 transition-colors duration-200 cursor-pointer font-medium"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 구분선 */}
        <div className="border-t border-teal-700/50 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
            {/* 저작권 및 사업자 정보 */}
            <div className="text-center md:text-left">
              <p className="text-sm md:text-base text-teal-200/60 font-medium mb-1 md:mb-2">
                &copy; 2024 ROBO Asset Grid. All rights reserved.
              </p>
              <p className="text-xs md:text-sm text-teal-200/40 font-medium">
                사업자등록번호: 123-45-67890 | 대표이사: 이동우
              </p>
              <div className="mt-2 flex items-center justify-center md:justify-start gap-3">
                <Link
                  to="/en"
                  className="text-xs md:text-sm text-teal-200/60 hover:text-teal-300 transition-colors duration-200 cursor-pointer font-medium"
                >
                  English Version
                </Link>
                <span className="text-teal-200/40">|</span>
                <a
                  href="https://readdy.ai/?ref=logo"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-xs md:text-sm text-teal-200/40 hover:text-teal-300 transition-colors duration-200 cursor-pointer font-medium"
                >
                  Powered by Readdy
                </a>
              </div>
            </div>

            {/* 소셜 미디어 링크 */}
            <div className="flex items-center gap-3 md:gap-4">
              {socialLinks.map((social, sIdx) => (
                <a
                  key={sIdx}
                  href={social.href}
                  aria-label={social.label}
                  rel="nofollow"
                  className="w-9 md:w-10 h-9 md:h-10 bg-white/10 hover:bg-teal-500 rounded-lg flex items-center justify-center transition-all duration-300 cursor-pointer group"
                >
                  <i
                    className={`${social.icon} text-base md:text-lg text-teal-200/70 group-hover:text-white`}
                  ></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
